import { PaginationModel, SortModel } from '@spartacus/core';

export interface DeliveryNotesOverview {
  entries?: DeliveryNote[];
  pagination?: PaginationModel;
  sorts?: SortModel[];
}

export interface DeliveryNote {
  deliveryNumber?: string;
  deliveryText?: string;
  deliveryMethod?: string;
  expressShippingOption?: string;
  formattedReleaseDate?: string;
  pdfUrl?: string;
  releaseDate?: Date;
  trackingCode?: string;
  trackingUrl?: string;
  units?: number;
  weightKG?: number;
  formattedWeightKG?:string;
  entries?: DeliveryNoteItem[];
}

export interface DeliveryNoteItem {
  orderNumber?: string;
  position?: number;
  productCode?: number;
  productUrl?: string;
  deliveredQuantity?: number;
  unit?: string;
  description?: string;
  imei?: string;
}

export interface DeliveryNotesOverviewRequest {
  debitorNumber?: string;
  deliveryDateFrom?: string;
  deliveryDateTo?: string;
  deliveryId?: string;
  productCode?: string;
}

export interface DeliveryNotesOverviewSortData {
  sortOption?: string;
  sortDirection?: string;
}

export enum DeliveryNotesOverviewDefaultSortOptions {
  deliveryNumber,
  deliveryMethod,
  releaseDate,
  trackingUrl,
  weightKG,
  units
}


export enum DeliveryNoteDetailsSortOptions {
  orderNumber,
  position,
  productCode,
  deliveredQuantity,
  description,
  imei
}
